/**
 * Community API Endpoints
 * Centralized endpoint definitions for community/posts features
 * Base URL: http://127.0.0.1:1111 (from .env)
 * Prefix: /frontend
 */

const COMMUNITY_ENDPOINTS = {
  // Categories
  GET_ALL_CATEGORIES: "/frontend/get-all-categories",

  // Posts
  CREATE_POST: "/frontend/create-post",
  CREATE_PREVIEW: "/frontend/link-preview",
  EDIT_POST: "/frontend/update-post",
  GET_ALL_POSTS: "/frontend/get-all-posts",
  TRENDING_POSTS: "/frontend/trending-posts",
  HOT_TOPICS: "/frontend/hot-topics",
  POPULAR_TOPICS: "/frontend/popular-topics",
  GET_POST_BY_ID: (postId) => `/frontend/get-post-by-id/${postId}`,
  DELETE_POST: (postId) => `/frontend/delete-post/${postId}`,
  REPORT_POST: (postId) => `/frontend/posts/${postId}/report`,

  // Post Interactions
  LIKE_UNLIKE_POST: "/frontend/add-like",

  // Post Reactions (Emoji Reactions)
  ADD_REACTION: "/frontend/posts/reactions/add",
  REMOVE_REACTION: "/frontend/posts/reactions/remove",
  GET_REACTIONS: "/frontend/posts/reactions/get",

  // Comments
  ADD_COMMENT: "/frontend/add-comment",
  EDIT_COMMENT: "/frontend/edit-comment",
  GET_POST_COMMENTS: "/frontend/get-post-comments",
  DELETE_COMMENT: (commentId) => `/frontend/delete-comment/${commentId}`,
  LIKE_UNLIKE_COMMENT: "/frontend/comment/like",

  // Comment Reactions (Emoji Reactions)
  ADD_COMMENT_REACTION: "/frontend/comments/reactions/add",
  REMOVE_COMMENT_REACTION: "/frontend/comments/reactions/remove",
  GET_COMMENT_REACTIONS: "/frontend/comments/reactions/get",
  SEARCH_USERS: "/frontend/search-users",
  REPOST: "/frontend/repost",

  FOLLOW: "/frontend/follow",
  UNFOLLOW: (userId) => `/frontend/unfollow/${userId}`,

  // Post Saves
  TOGGLE_POST_SAVE: "/frontend/post-saves/toggle",
  GET_SAVED_POSTS: "/frontend/post-saves",
  CHECK_POST_SAVED: "/frontend/post-saves/check",
  GET_FOLLOWING: (userId) => `/frontend/following/${userId}`,
  GET_FOLLOWERS: (userId) => `/frontend/followers/${userId}`,
  GET_FOLLOW_STATS: (userId) => `/frontend/follow-stats/${userId}`,
  GET_FOLLOW_STATUS: (userId) => `/frontend/follow-status/${userId}`,
  
  // User Profile
  GET_USER_QUICK_INFO: (userId) => `/frontend/user-quick-info/${userId}`,

  // Requested role wishlist (community "Not seeing your profession?" input)
  SUBMIT_REQUESTED_ROLE: "/frontend/requested-role",

  // Poll
  GET_ACTIVE_POLL: "/frontend/poll/active",
  SUBMIT_POLL_VOTE: "/frontend/poll/vote",

  // Free-tier weekly allowance (posts + comments remaining this week)
  COMMUNITY_USAGE: "/frontend/community-usage",
};

export default COMMUNITY_ENDPOINTS;
